// Core routes
import Recharge from 'js/pages/recharge/index.js'
import News from 'js/pages/news'
import Faqs from 'js/pages/faqs'
import DownloadableResources from 'js/pages/downloadable-resources'
import PrePurchaseFares from 'js/pages/pre-purchase-fares'
import MovementsHistory from 'js/pages/movements-history'

// Custom routes
import InfoCards from 'js/pages/info-cards'
import NetworkMap from 'js/pages/network-map'

const meta = {
  layoutInfo: true
}

export default [
  // Core routes
  {
    path: 'recharge',
    name: 'municipality-recharge',
    component: Recharge,
    meta
  },
  {
    path: ':media_code/:media_type/recharge',
    name: 'municipality-recharge-data',
    component: Recharge,
    meta
  },
  {
    path: 'news/:slug?',
    name: 'municipality-faqs',
    component: News,
    meta
  },
  {
    path: 'notices',
    name: 'municipality-news',
    component: Faqs,
    meta
  },
  {
    path: 'schedules',
    name: 'municipality-schedules',
    component: DownloadableResources,
    props: { type: 'schedules' },
    meta
  },
  {
    path: 'pre-purchase-fares',
    name: 'municipality-pre-purchase-fares',
    component: PrePurchaseFares,
    meta
  },
  {
    path: 'movements-history',
    name: 'municipality-movements-history',
    component: MovementsHistory,
    meta
  },
  // Custom Routes
  {
    path: 'fares',
    name: 'municipality-fares',
    component: DownloadableResources,
    props: { type: 'fares' },
    meta
  },
  {
    path: 'info-cards',
    name: 'info-cards',
    component: InfoCards,
    meta
  },
  {
    path: 'network-map',
    name: 'municipality-network-map',
    component: NetworkMap,
    meta
  }
]
